module.exports = __webpack_public_path__ + "static/media/uiux.a8d9daf2.svg";